<mat-spinner *ngIf="showSpinner; else notSpinner"></mat-spinner>
<ng-template #notSpinner>
	<div class="header-button">
		<div>
			<b>
				{{ wine.name }}
			</b>
			-> nota {{ media ? media.toFixed(2) : '--' }}
		</div>

		<button mat-raised-button (click)="voltar()">
			Voltar
		</button>
	</div>

	<div class="flex-container">
		<div class="flex-item-first">
			<img class="image-vinho" [src]="transformImageUrl(wine.image_url)"
				onerror="this.src='../../../assets/img/dump3.png'" alt="Imagens de produtos">
		</div>
		<div class="flex-item-second">
			<h3><b>Produtor: </b> {{ wine.producer ? wine.producer : '--' }}</h3>
			<h3><b>País: </b> {{ wine.country ? wine.country : '--' }}</h3>
			<h3><b>Descrição: </b> {{ wine.description ? wine.description : '--' }}</h3>
			<h3 *ngIf="wine.reviews.length" class="avaliacao-container">
				<b>Média de avaliações: </b>
				<div *ngFor="let item of [].constructor(estrelasOn); let i = index;">
					<img class="estrela-item" src="../../../assets/img/star_on.gif" alt="acesas">
				</div>
				<div *ngFor="let item of [].constructor(estrelasOff); let i = index;">
					<img class="estrela-item" src="../../../assets/img/star_off.gif" alt="apagadas">
				</div>
			</h3>
		</div>
		<div class="flex-item-terc">
			<h3><b>Tipo de vinho: </b> {{ wine.type ? wine.type : '--' }}</h3>
			<h3><b>Tipo de uva: </b> {{ wine.type_grape ? wine.type_grape : '--' }}</h3>
			<h3><b>Harmonização: </b> {{ wine.harmonizing ? wine.harmonizing : '--' }}</h3>
		</div>
	</div>

	<div *ngIf="wine.reviews.length > 0; else notReviews">
		<mat-list *ngFor="let review of wine.reviews">
			<mat-list-item>
				{{ review.review }}
				<h3 class="avaliacao-container-2">
					<div *ngFor="let item of [].constructor(+(review.evaluation.toFixed(0))); let i = index;">
						<img class="estrela-item" src="../../../assets/img/star_on.gif" alt="acesas">
					</div>
					<div *ngFor="let item of [].constructor(5 - (+(review.evaluation.toFixed(0)))); let i = index;">
						<img class="estrela-item" src="../../../assets/img/star_off.gif" alt="apagadas">
					</div>
				</h3>
			</mat-list-item>
			<mat-divider></mat-divider>
		</mat-list>
	</div>
	<ng-template #notReviews>
		<span class="container-wrapper">Não há reviews para este vinho</span>
	</ng-template>

	<mat-card *ngIf="isLogged" class="mat-elevation-z8">
		<form>
			<mat-form-field>
				<mat-label>Comentário</mat-label>
				<textarea [(ngModel)]="comentario" matInput name="comentario"></textarea>
			</mat-form-field>

			<mat-form-field>
				<mat-label>Nota</mat-label>
				<mat-select [(ngModel)]="nota" name="nota">
					<mat-option [value]=1>1</mat-option>
					<mat-option [value]=2>2</mat-option>
					<mat-option [value]=3>3</mat-option>
					<mat-option [value]=4>4</mat-option>
					<mat-option [value]=5>5</mat-option>
				</mat-select>
			</mat-form-field>
		</form>
		<button mat-raised-button (click)="createReview()" color="primary">
			Salvar
		</button>
	</mat-card>
</ng-template>